import { Component, forwardRef, Input } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NgControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { ValidationService } from '@shared/services/validation.service';

@Component({
  selector: 'app-date-field',
  template: `
    <nz-input-group [nzSuffix]="suffixIconCalendar" style="z-index:0;">
      <input
        sMask
        mask-type="DATE"
        nz-input
        [(ngModel)]="dateModel"
        (input)="onChangeInput($event.target.value)"
        placeholder="__/__/____"
        [disabled]="isDisabled"
      />
    </nz-input-group>
    <ng-template #suffixIconCalendar>
    <i nz-icon nzType="calendar" nzTheme="outline"></i>
    </ng-template>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateFieldComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => DateFieldComponent),
      multi: true,
    },
  ],
})
export class DateFieldComponent implements ControlValueAccessor, Validator {
  dateModel: string;
  dateControl: NgControl;

  private _value: string;

  onChange: any;
  onTouched: any;

  isDisabled = false;

  @Input()
  disableFutureDate = false;
  @Input()
  disablePastDate = false;

  constructor() {}

  writeValue(obj: any): void {
    this.value = obj;
    this.dateModel = this.value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  validate(control: AbstractControl): ValidationErrors {
    return ValidationService.date(control, this.disableFutureDate, this.disablePastDate);
  }

  set value(value: string) {
    if (this._value !== value && this.onChange) {
      this.onChange(value);
      this.onTouched();
    }
    this._value = value;
  }

  get value() {
    return this._value;
  }

  onChangeInput(value: string) {
    this.value = value;
  }
}
